/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ClassPlacementsRoute extends Route {
  queryParams = {
    fromYear: {
      refreshModel: true,
    },
    toYear: {
      refreshModel: true,
    },
  };

  // Services
  @service
  session;

  @service
  store;

  model(params) {
    let schoolId = this.get('session.activeSchool');
    let fromYear = params.fromYear || moment().year();
    let toYear = params.toYear || fromYear + 1;
    return hash({
      fromGroups: this.store.query('group', { schoolId, year: fromYear }),
      toGroups: this.store.query('group', {
        schoolId,
        year: toYear,
        groupType: GroupType.HOMEROOM,
      }),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
